import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const Whoweareservice = {
  getList: async () => {
    const response = await apiService.get("/maintainance/who-we-are");
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/maintainance/who-we-are", data);
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/maintainance/who-we-are/${id}`);

    return response.data;
  },

  getbySlug: async (slug) => {
    const response = await apiService.get(`/maintainance/who-we-are/by-slug/${slug}`);

    return response.data;
  },
  update: async (id, updateData) => {
    try {
      const response = await apiService.put(`/maintainance/who-we-are/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/maintainance/who-we-are/${id}`);
    return response.data;
  },
};
export default Whoweareservice;